<div class="image-list" *ngIf="images.length > 0">
  <ng-container *ngFor="let img of images; let i = index">
    <div *ngIf="!(hidePrimary && img.primary)" class="photo-border">
      <img height="58" width="58" [images-src]="img" data-gravity="center" data-quality="low" [images-show]="images" [start-image]="i" />
    </div>
  </ng-container>
</div>
